import { render, staticRenderFns } from "./FuncionesGlobalesPantalla.vue?vue&type=template&id=03a3e75c&"
import script from "./FuncionesGlobalesPantalla.vue?vue&type=script&lang=ts&"
export * from "./FuncionesGlobalesPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('03a3e75c', component.options)
    } else {
      api.reload('03a3e75c', component.options)
    }
    module.hot.accept("./FuncionesGlobalesPantalla.vue?vue&type=template&id=03a3e75c&", function () {
      api.rerender('03a3e75c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/FuncionesGlobales/FuncionesGlobalesPantalla.vue"
export default component.exports